/**
 * O céu do Easy HUB.
 *
 * As estrelas são geradas por um PRNG de semente fixa, então a lista é sempre
 * a mesma — e é justamente por isso que ela mora aqui e não dentro de uma
 * tela: o login e a antessala desenham o MESMO céu, nas mesmas posições. Quem
 * entra tem a sensação de atravessar uma porta e continuar no mesmo lugar, em
 * vez de trocar de cenário.
 *
 * Gerado uma vez, na importação do módulo. Não é estado reativo e não deve
 * virar: nada aqui muda depois de carregado.
 */

export interface Star {
  /** left, em porcentagem com o sufixo. */
  l: string
  /** top, idem. */
  t: string
  /** Lado do quadrado, em px. Uma em cada cinco é maior. */
  s: string
  o: string
  /** '1' nas que cintilam — uma a cada nove. */
  tw: string
}

export const STARS: Star[] = (() => {
  let s = 11
  const r = () => {
    s |= 0
    s = (s + 0x6d2b79f5) | 0
    let x = Math.imul(s ^ (s >>> 15), 1 | s)
    x = (x + Math.imul(x ^ (x >>> 7), 61 | x)) ^ x
    return ((x ^ (x >>> 14)) >>> 0) / 4294967296
  }
  return Array.from({ length: 150 }, (_, i) => ({
    l: (r() * 100).toFixed(2) + '%',
    t: (r() * 100).toFixed(2) + '%',
    s: (r() < 0.2 ? 2 : 1) + 'px',
    o: (0.1 + r() * 0.3).toFixed(2),
    tw: i % 9 === 0 ? '1' : '0',
  }))
})()
